import { render, staticRenderFns } from "./WorkforceStatisticsPage.vue?vue&type=template&id=f6e5c7e0&scoped=true&"
import script from "./WorkforceStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./WorkforceStatisticsPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceStatisticsPage.vue?vue&type=style&index=0&id=f6e5c7e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e5c7e0",
  null
  
)

export default component.exports